export default {
  fontFamily: 'neuzeit-grotesk, sans-serif',
  h1: {
    fontSize: 32,
    letterSpacing: 0,
    fontWeight: 300,
    color: '#000000',
  },
  h2: {
    fontSize: 24,
    letterSpacing: 0,
    fontWeight: 300,
    color: '#000000',
  },
  h3: {
    fontSize: 20,
    letterSpacing: 0,
    fontWeight: 300,
    color: '#000000',
  },
  h4: {
    fontSize: 16,
    letterSpacing: 0.8,
    fontWeight: 400,
    opacity: 0.54,
    textTransform: 'uppercase',
    color: '#000000',
  },
  h5: {
    fontSize: 14,
    letterSpacing: 1,
    fontWeight: 400,
    opacity: 0.54,
    textTransform: 'uppercase',
    color: '#000000',
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
  },
};
